import { Entity } from "@common/types/entity";

export interface PreviewEntityScope {
    isEntityIncluded: (entity: Pick<Entity, "isPersonal">) => boolean;
    noEntityReason: string;
}

export const ALL_PREVIEW_ENTITIES: PreviewEntityScope = {
    isEntityIncluded: () => true,
    noEntityReason: "No entities to preview. Add an entity to a client first.",
};

export const BUSINESS_PREVIEW_ENTITIES: PreviewEntityScope = {
    isEntityIncluded: (entity) => !entity.isPersonal,
    noEntityReason:
        "No business entities to preview. Add a business entity to a client first.",
};
